import { render, staticRenderFns } from "./GenerateSingleReport.vue?vue&type=template&id=be3374de&"
import script from "./GenerateSingleReport.vue?vue&type=script&lang=ts&"
export * from "./GenerateSingleReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports